// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  position: relative;
  z-index: 11;
}

.hero__imgContainer {
  height: 15rem;
  /* margin: 0 -13%; */
  position: relative;
}

.hero__imgContainer.primary {
  background-color: #aa4e4d;
}

.hero__imgContainer.secondary-300 ~ .hero__content h1 {
  color: var(--clr-black);
}

.hero__imgContainer.secondary-300 {
  background-color: #f8f3ed;
}

.hero__imgContainer.no-img img {
  display: none;
}

.hero__imgContainer::after {
  content: "";
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  position: absolute;
}

.hero__imgContainer.no-img::after {
  display: none;
}

.hero__imgContainer img {
  width: 100%;
  object-position: center 55%;
  height: inherit;
  object-fit: cover;
  /* object-position: 0 -15rem; */
}

.hero__content {
  width: 80%;
  display: flex;
  align-items: flex-start;
  max-width: 1200px;
  flex-direction: column-reverse;
  justify-content: space-between;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  z-index: 11;
  left: 50%;
  transform: translate(-50%, -50%);
}

.hero__title {
  color: var(--clr-light);
  /* font-size: 1.5rem; */
  font-size: 1.1rem;
  font-weight: 400;
}

.hero__title strong {
  /* font-size: 3.5rem; */
  font-size: 1.5rem;
}

.hero__date {
  cursor: pointer;
  position: relative;
}

.hero__date > div:first-of-type {
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  justify-content: center;
  font-family: "Avenir Next";
  border-radius: 0.5em;
  background: var(--clr-secondary);
  /* padding: 1.25em 1.5em; */
  padding: 0.75em;
  margin-bottom: 0.5rem;
}

.hero__date > div:first-of-type h4 {
  color: var(--clr-gray900);
  margin-bottom: 0.25rem;
  display: none;
}

.hero__date > div:first-of-typespan {
  font-weight: bolder;
  font-size: 0.8rem;
}

/* if in coffret page */
.hero__leftSection {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.hero__optionalMobile,
.hero__optional {
  display: block;
  margin-top: -0.5rem;
  font-size: 1.25rem;
  font-weight: 500;
  color: var(--clr-light);
}

.hero__optionalMobile {
  font-size: 1.1rem;
}

.hero__optional {
  display: none;
}

.hero__content form {
  width: 100%;
  max-width: 25rem;
  display: flex;
  align-items: center;
  background: var(--clr-gray300);
  padding: 0.75em 1em;
  border-radius: 0.75em;
  margin-top: 1rem;
}

.hero__content form input {
  width: 100%;
  margin-left: 0.5rem;
  border: none;
  background-color: transparent;
  outline: none;
}

.hero__content form img {
  width: 1.5rem;
}

@media (min-width: 375px) {
  .hero__imgContainer {
    height: 12rem;
    /* margin: 0 -13%; */
    position: relative;
  }
}

@media (min-width: 500px) {
  .hero__imgContainer {
    height: 15rem;
  }

  .hero__title strong {
    font-size: 1.8rem;
  }
}

@media (min-width: 768px) {
  .hero {
    /* top: -7.25rem; */
    margin-top: -7.25rem;
  }

  .hero__imgContainer {
    height: 25rem;
    /* height: 20rem; */
    /* top: -10rem; */
  }

  .hero__imgContainer.medium {
    height: 40rem;
  }
  .hero__imgContainer.medium img {
    object-position: center;
  }

  .hero__content {
    width: 80%;
    display: flex;
    align-items: flex-start;
    max-width: 1200px;
    /* flex-direction: row; */
    justify-content: space-between;
    margin: 0 auto;
    position: absolute;
    /* top: 75%; */
    top: 50%;
    left: 50%;
    transform: translate(-50%, -70%);
  }

  .hero__content.model2 {
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .hero__optionalMobile,
  .hero__title {
    font-size: 1.25rem;
  }

  .hero__title strong {
    font-size: 2.5rem;
  }

  .hero__date > div:first-of-type {
    border-radius: 1em;
    padding: 1.25em 1.5em;
    margin-bottom: 1rem;
  }
}

@media (min-width: 992px) {
  .hero__date > div:first-of-type h4 {
    display: block;
    font-size: 0.9rem;
  }
  .hero__content {
    align-items: center;
    flex-direction: row;
  }

  .hero__title {
    font-size: 1.25rem;
  }

  .hero__title strong {
    font-size: 3rem;
  }

  .hero__date span {
    font-size: 1rem;
  }

  .hero__leftSection {
    width: -moz-fit-content;
    width: fit-content;
  }

  .hero__optional {
    display: block;
  }

  .hero__optionalMobile {
    display: none;
  }
}

@media (min-width: 1200px) {
  .hero__title {
    font-size: 1.5rem;
  }

  .hero__title strong {
    font-size: 3.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Hero/Hero.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,8BAA8B;EAC9B,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,oBAAoB;EACpB,gCAAgC;EAChC,2BAA2B;EAC3B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,oBAAoB;IACpB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;IACzB,8BAA8B;IAC9B,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,QAAQ;IACR,SAAS;IACT,gCAAgC;EAClC;;EAEA;IACE,QAAQ;IACR,gCAAgC;EAClC;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAkB;IAAlB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".hero {\n  position: relative;\n  z-index: 11;\n}\n\n.hero__imgContainer {\n  height: 15rem;\n  /* margin: 0 -13%; */\n  position: relative;\n}\n\n.hero__imgContainer.primary {\n  background-color: #aa4e4d;\n}\n\n.hero__imgContainer.secondary-300 ~ .hero__content h1 {\n  color: var(--clr-black);\n}\n\n.hero__imgContainer.secondary-300 {\n  background-color: #f8f3ed;\n}\n\n.hero__imgContainer.no-img img {\n  display: none;\n}\n\n.hero__imgContainer::after {\n  content: \"\";\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n}\n\n.hero__imgContainer.no-img::after {\n  display: none;\n}\n\n.hero__imgContainer img {\n  width: 100%;\n  object-position: center 55%;\n  height: inherit;\n  object-fit: cover;\n  /* object-position: 0 -15rem; */\n}\n\n.hero__content {\n  width: 80%;\n  display: flex;\n  align-items: flex-start;\n  max-width: 1200px;\n  flex-direction: column-reverse;\n  justify-content: space-between;\n  margin: 0 auto;\n  position: absolute;\n  top: 50%;\n  z-index: 11;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.hero__title {\n  color: var(--clr-light);\n  /* font-size: 1.5rem; */\n  font-size: 1.1rem;\n  font-weight: 400;\n}\n\n.hero__title strong {\n  /* font-size: 3.5rem; */\n  font-size: 1.5rem;\n}\n\n.hero__date {\n  cursor: pointer;\n  position: relative;\n}\n\n.hero__date > div:first-of-type {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  position: relative;\n  justify-content: center;\n  font-family: \"Avenir Next\";\n  border-radius: 0.5em;\n  background: var(--clr-secondary);\n  /* padding: 1.25em 1.5em; */\n  padding: 0.75em;\n  margin-bottom: 0.5rem;\n}\n\n.hero__date > div:first-of-type h4 {\n  color: var(--clr-gray900);\n  margin-bottom: 0.25rem;\n  display: none;\n}\n\n.hero__date > div:first-of-typespan {\n  font-weight: bolder;\n  font-size: 0.8rem;\n}\n\n/* if in coffret page */\n.hero__leftSection {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.hero__optionalMobile,\n.hero__optional {\n  display: block;\n  margin-top: -0.5rem;\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: var(--clr-light);\n}\n\n.hero__optionalMobile {\n  font-size: 1.1rem;\n}\n\n.hero__optional {\n  display: none;\n}\n\n.hero__content form {\n  width: 100%;\n  max-width: 25rem;\n  display: flex;\n  align-items: center;\n  background: var(--clr-gray300);\n  padding: 0.75em 1em;\n  border-radius: 0.75em;\n  margin-top: 1rem;\n}\n\n.hero__content form input {\n  width: 100%;\n  margin-left: 0.5rem;\n  border: none;\n  background-color: transparent;\n  outline: none;\n}\n\n.hero__content form img {\n  width: 1.5rem;\n}\n\n@media (min-width: 375px) {\n  .hero__imgContainer {\n    height: 12rem;\n    /* margin: 0 -13%; */\n    position: relative;\n  }\n}\n\n@media (min-width: 500px) {\n  .hero__imgContainer {\n    height: 15rem;\n  }\n\n  .hero__title strong {\n    font-size: 1.8rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .hero {\n    /* top: -7.25rem; */\n    margin-top: -7.25rem;\n  }\n\n  .hero__imgContainer {\n    height: 25rem;\n    /* height: 20rem; */\n    /* top: -10rem; */\n  }\n\n  .hero__imgContainer.medium {\n    height: 40rem;\n  }\n  .hero__imgContainer.medium img {\n    object-position: center;\n  }\n\n  .hero__content {\n    width: 80%;\n    display: flex;\n    align-items: flex-start;\n    max-width: 1200px;\n    /* flex-direction: row; */\n    justify-content: space-between;\n    margin: 0 auto;\n    position: absolute;\n    /* top: 75%; */\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -70%);\n  }\n\n  .hero__content.model2 {\n    top: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  .hero__optionalMobile,\n  .hero__title {\n    font-size: 1.25rem;\n  }\n\n  .hero__title strong {\n    font-size: 2.5rem;\n  }\n\n  .hero__date > div:first-of-type {\n    border-radius: 1em;\n    padding: 1.25em 1.5em;\n    margin-bottom: 1rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .hero__date > div:first-of-type h4 {\n    display: block;\n    font-size: 0.9rem;\n  }\n  .hero__content {\n    align-items: center;\n    flex-direction: row;\n  }\n\n  .hero__title {\n    font-size: 1.25rem;\n  }\n\n  .hero__title strong {\n    font-size: 3rem;\n  }\n\n  .hero__date span {\n    font-size: 1rem;\n  }\n\n  .hero__leftSection {\n    width: fit-content;\n  }\n\n  .hero__optional {\n    display: block;\n  }\n\n  .hero__optionalMobile {\n    display: none;\n  }\n}\n\n@media (min-width: 1200px) {\n  .hero__title {\n    font-size: 1.5rem;\n  }\n\n  .hero__title strong {\n    font-size: 3.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
